import { Controller } from '@hotwired/stimulus'
import tippy from 'tippy.js'
import { Browser } from '../utils'

// Connects to data-controller="tooltip"
export default class extends Controller {
  static targets = ['element']
  static values = {
    trigger: { type: String, default: 'mouseenter' },
    placement: { type: String, default: 'top' },
    animation: { type: String, default: 'fade' },
    hideDelay: { type: Number, default: 0 },
    onTouch: { type: Boolean, default: false },
  }

  connect() {
    if (Browser.isTouchDevice && !this.onTouchValue) return

    this.tooltip = tippy(this.#tooltipElement, {
      content: this.#content,
      trigger: this.#trigger,
      placement: this.placementValue,
      animation: this.animationValue,
      theme: 'light-border',
      delay: [50, 50],
      duration: [100, 100],
      onShown:
        this.hideDelayValue > 0
          ? (instance) => {
              this.timeout = setTimeout(() => this.hide(), this.hideDelayValue)
            }
          : undefined,
    })
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
    this.hide()
    this.tooltip?.destroy()
  }

  toggleDisable(event) {
    if (event.currentTarget.checked) {
      this.tooltip?.disable()
    } else {
      this.tooltip?.enable()
    }
  }

  hide() {
    this.tooltip?.hide()
  }

  get #trigger() {
    return Browser.isTouchDevice && this.onTouchValue && this.triggerValue === 'mouseenter'
      ? 'click'
      : this.triggerValue
  }

  get #content() {
    return this.#tooltipElement.ariaLabel || this.#tooltipElement.dataset.title
  }

  get #tooltipElement() {
    return this.hasElementTarget ? this.elementTarget : this.element
  }
}
